import { Box, Text } from '@wix/design-system';
import React from 'react';
import { GiftIcon } from '../GiftIcon';
import { useCurrentModule } from '../ModuleProvider';
export const FreeDomainMatchCycleLabel = _ref => {
  let {
    yearCount,
    textClassName,
    rowClassName,
    align,
    width
  } = _ref;
  const module = useCurrentModule();
  const {
    Trans
  } = module.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    gap: "4px",
    className: rowClassName,
    align: align,
    width: width
  }, /*#__PURE__*/React.createElement(GiftIcon, null), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    className: textClassName
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "premium-purchase-plan.cycle-selection.free-domain-match-cycle",
    values: {
      years: yearCount
    },
    components: {
      strong: /*#__PURE__*/React.createElement("strong", null)
    }
  })));
};
//# sourceMappingURL=FreeDomainMatchCycleLabel.js.map